export var shouldFetchExactCount = function (totalRecordsExact) { return totalRecordsExact === false; };
export var isCountCapped = function (totalRecordsExact, exactTotalRecords) { return totalRecordsExact === false && exactTotalRecords === undefined; };
